//      

import React, { Component } from 'react';

import Select from './Select';


              
                            
                             
                          
                      
                       
                    
  
              
                     
                      
                   
  

export default class StateManager extends Component               {
  static defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null,
  };
  state = {
    inputValue: this.props.inputValue !== undefined ? this.props.inputValue : this.props.defaultInputValue,
    menuIsOpen: this.props.menuIsOpen !== undefined ? this.props.menuIsOpen : this.props.defaultMenuIsOpen,
    value: this.props.value !== undefined ? this.props.value : this.props.defaultValue,
  };
  getProp(key        ) {
    return this.props[key] !== undefined ? this.props[key] : this.state[key];
  }
  callProp(name        , ...args     ) {
    if (typeof this.props[name] === 'function') {
      return this.props[name](...args);
    }
  }
  onChange = (value     ) => {
    this.callProp('onChange', value);
    this.setState({ value });
  };
  onInputChange = (inputValue     ) => {
    // TODO: for backwards compatibility, we allow the prop to return a new
    // value, but now inputValue is a controllable prop we probably shouldn't
    const newValue = this.callProp('onInputChange', inputValue);
    this.setState({
      inputValue: newValue !== undefined ? newValue : inputValue,
    });
  };
  onMenuOpen = () => {
    this.callProp('onMenuOpen');
    this.setState({ menuIsOpen: true });
  };
  onMenuClose = () => {
    this.callProp('onMenuClose');
    this.setState({ menuIsOpen: false });
  };
  render() {
    return (
      <Select
        {...this.props}
        inputValue={this.getProp('inputValue')}
        menuIsOpen={this.getProp('menuIsOpen')}
        onChange={this.onChange}
        onInputChange={this.onInputChange}
        onMenuClose={this.onMenuClose}
        onMenuOpen={this.onMenuOpen}
        value={this.getProp('value')}
      />
    );
  }
}
